import { AvailableCodesTable } from './AvailableCodesTable';

export default AvailableCodesTable;
